angular.module('wco.directives.serviceCodeParam', [])
.controller('WcoServiceCodeParamController', ['$scope', function($scope) {
    $scope.dateOptions = {
        startingDay: 1
    };

    $scope.parsePackingSlipComment = function(serviceCodeParam){
        let comment = $scope.packingSlip.COMMENT;

        let arrayOfLines = comment.match(/[^\r\n]+/g);
        let searchString = '#SV' + serviceCodeParam.NUMBER;
        let newStringValue = '';
        arrayOfLines.forEach(function(element,index){
           if (element.indexOf(searchString) == 0){
               let lineToAdd = element.replace(searchString, '');
               lineToAdd = lineToAdd.trim();
               if (newStringValue != ''){
                   newStringValue = newStringValue + "\n";
               }
               newStringValue = newStringValue + lineToAdd;
           }
        });
        serviceCodeParam.VALUE = newStringValue;
    }
}])
.directive('wcoServiceCodeParam', ['$timeout', function($timeout) {
    return {
        controller: 'WcoServiceCodeParamController',
        controllerAs: 'ServiceCodeParamController',
        templateUrl: function(element, attrs) {
            return attrs.templateUrl || 'angular/directives/serviceCodeParam.html';
        },
        replace: true,
        scope:{
            serviceCodeParam: '=',
            packingSlip: '='
        },
        link: function(scope, element, attrs) {
            $timeout(() => {
                let keyboardPosition = {
                    of: $('.keyboard-container'),
                    my: 'center top',
                    at: 'center top',
                    at2: 'center bottom'
                };

                let paramType = scope.serviceCodeParam.TYPE;
                if (paramType == 'INTEGER') {
                    $(element).find('.service-code-number-input').keyboard({
                        layout: 'customnum',
                        autoAccept: true,
                        position: keyboardPosition
                    });
                }
                else if (paramType == 'VARCHAR') {
                    $(element).find('.service-code-text-input').keyboard({
                        layout: 'customwebco',
                        autoAccept: true,
                        position: keyboardPosition
                    });
                }
                else if (paramType == 'DATE') {
                    $(element).find('.service-code-date-input').keyboard({
                        layout: 'customnumwithpoint',
                        autoAccept: true,
                        position: keyboardPosition,
                        openOn: 'click'
                    });
                }
                else if (paramType == 'TIME') {
                    $(element).find('.service-code-number-input input').keyboard({
                        layout: 'customnum',
                        autoAccept: true,
                        position: keyboardPosition
                    });
                }
            });
        }
    };
}]);